// extracted by mini-css-extract-plugin
export var dropdownContainer = "_mo-0";
export var leftAlign = "_mo-4";
export var listItem = "_mo-2";
export var listItemWrapper = "_mo-1";
export var operationText = "_mo-3";